import { FieldValues } from 'react-hook-form';

export const clearEmptyValues = (data: FieldValues) => {
  Object.keys(data).forEach((key: string) => {
    if (data[key] === '' || data[key] === null || data[key] === undefined) {
      delete data[key];
    }
  });
};
